<section class="availability-kpis" aria-label="Selected-period availability KPIs" *ngIf="kpis">
  <button
    type="button"
    class="kpi-card"
    [class.selected]="!selectedTeam"
    (click)="selectTeam('')"
  >
    <span class="kpi-name">Total</span>
    <strong>{{ kpis.total.availableAtLeastOnce }} / {{ kpis.total.total }}</strong>
    <small>free at least once in selected period</small>
    <small class="kpi-entire">
      <b>{{ kpis.total.freeForEntireSelectedRange }}</b> free for entire period
    </small>
  </button>
  <button
    *ngFor="let item of kpis.teams; trackBy: trackByTeam"
    type="button"
    class="kpi-card"
    [class.selected]="selectedTeam === item.team"
    (click)="selectTeam(item.team)"
  >
    <span class="kpi-name">{{ item.team }}</span>
    <strong>{{ item.availableAtLeastOnce }} / {{ item.total }}</strong>
    <small>free at least once in selected period</small>
    <small class="kpi-entire">
      <b>{{ item.freeForEntireSelectedRange }}</b> free for entire period
    </small>
  </button>
</section>
